module.exports = __webpack_public_path__ + "img/img2.75fe96e3.png";